import React from "react";
import { Layout } from "../components/Layout";

let Send = () => {
    return (
        <Layout>
            <h2>Send notification</h2>
        </Layout>
    );
};

export { Send };



// WEBPACK FOOTER //
// ./src/pages/Send.js